// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '@shared/utils/theme'
import Button from '../../components/Button'

const WelcomePageSimulationContainer = styled.div`
  margin-top: 10px;
  margin-left: 20px;
  display: flex;
  align-items: flex-start;
  .simulation-btn {
    background: ${ theme.palette.white };
    color: ${ theme.palette.blue };
    border: 1px solid ${ theme.palette.blue };
  }

`

export default function WelcomePageSimulation({ ...props }) {
  return (
    <WelcomePageSimulationContainer>
      <Button className="simulation-btn" to='/simulation' >
        Je fais une simulation
      </Button>
    </WelcomePageSimulationContainer>
  )
}
